import { ButtonVariant, Button } from '@catalyze/ui';
import { Routes } from 'constants/routes';

export const Navigation = (
    <Button
        as="a"
        className="showMobile"
        href={Routes.SIGN_IN}
        variant={ButtonVariant.SECONDARY}
    >
        Sign in
    </Button>
);
